<template lang="html">
  <section class="app-update-award">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <p v-if="!getCurrentElement">
      Please go first to the "<a href="#" @click="navigateAway('read')"><strong><em>Read</em></strong></a>"
      tab and select the award you would like to update.
    </p>
    <form @submit.prevent="onSubmit" v-else class="text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="d-flex flex-wrap mb-3">
        <div v-if="displayMessage" class="font-size-larger font-weight-bold">
          <span :class="successUploaded ? 'text-success' : 'text-danger'" v-html="message"></span>
        </div>
        <div class="d-flex" v-if="fileToUpload">
          <div class="" v-show="imageShow">
            <div>{{ fileName }}</div>
            <div>
              <img class="img-thumbnail w-80" :alt="fileToUpload.name" :src="fileToRead" />
            </div>
          </div>
          <div v-if="!imageShow" class="d-flex align-self-center">
            <button type="button" class="btn btn-outline-dark mt-1 mb-1 ml-3" @click="showHideImage">
              Show File
            </button>
            <button v-if="displayMessage" type="button" class="btn btn-outline-danger mt-1 mb-1 ml-3" @click="onRemoveFile">
              Remove File
            </button>
            <button v-if="!displayMessage" type="button" class="btn btn-outline-success mt-1 mb-1 ml-3" @click="onUploadFile">
              Upload File
            </button>
            <button v-if="!displayMessage" type="button" class="btn btn-outline-warning mt-1 mb-1 ml-3" @click="replaceImage">
              Replace File
            </button>
          </div>
          <div v-if="imageShow" class="d-flex align-self-center">
            <button type="button" class="btn btn-outline-dark mt-1 mb-1 ml-3" @click="showHideImage">
              Hide
            </button>
            <button v-if="displayMessage" type="button" class="btn btn-outline-danger mt-1 mb-1 ml-3" @click="onRemoveFile">
              Remove
            </button>
            <button v-if="!displayMessage" type="button" class="btn btn-outline-success mt-1 mb-1 ml-3" @click="onUploadFile">
              Upload
            </button>
            <button v-if="!displayMessage" type="button" class="btn btn-outline-warning mt-1 mb-1 ml-3" @click="replaceImage">
              Replace
            </button>
          </div>
        </div>
      </div>
      <div class="custom-file mb-3" v-if="!fileToUpload">
        <input :class="(inputFileTouched && !fileName) ? 'is-invalid': ''"
               @blur="inputFileTouched = true" lang="en"
               type="file" id="fileToUpload" ref="fileToUpload" @change="handleFileToUpload"
               accept=".jpeg, .jpg, .png" class="custom-file-input" required>
        <label class="custom-file-label" for="fileToUpload">* Choose file</label>
        <div class="invalid-feedback">
          <div>Please add an image file of your award !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="awardLink" class="w-25 align-self-center">* Link :</label>
        <div class="w-100">
          <input :class="$v.dataForm.awardLink.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.awardLink.$touch() ||
                 (dataForm.awardLink = (dataForm.awardLink === '') ? savedData.link : dataForm.awardLink)"
                 v-model="dataForm.awardLink"
                 type="url" class="form-control" id="awardLink" required>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.awardLink.required">Please provide an external link to your award!</div>
            <div v-if="!$v.dataForm.awardLink.url">Please provide a valid url to your award !</div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="awardName" class="w-25 align-self-center">* Name :</label>
        <div class="w-100">
          <input :class="$v.dataForm.awardName.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.awardName.$touch() ||
                 (dataForm.awardName = (dataForm.awardName === '') ? savedData.name : dataForm.awardName)"
                 v-model="dataForm.awardName"
                 type="text" class="form-control" id="awardName" required>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.awardName.required">Please give a name to your award !</div>
            <div v-if="!$v.dataForm.awardName.minLength">
              Please enter award name of at least {{$v.dataForm.awardName.$params.minLength.min}} !
            </div>
            <div v-if="!$v.dataForm.awardName.maxLength">
              The name must not exceed {{$v.dataForm.awardName.$params.maxLength.max}} characters !
            </div>
            <div v-if="!$v.dataForm.awardName.alphaNum">You can't enter special characters !</div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="awardDateIssued" class="w-25 align-self-center">* Date issued :</label>
        <div class="w-100">
          <input :class="$v.dataForm.awardDateIssued.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.awardDateIssued.$touch() ||
                 (dataForm.awardDateIssued = (dataForm.awardDateIssued === '') ? savedData.date_issued : dataForm.awardDateIssued)"
                 v-model="dataForm.awardDateIssued"
                 type="date" id="awardDateIssued" class="form-control" required>
          <div class="invalid-feedback">Please enter issuing date of your award !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="awardDateExpiration" class="w-25 align-self-center">Date Expiration :</label>
        <div class="w-100">
          <input v-model="dataForm.awardDateExpiration" type="date" id="awardDateExpiration" class="form-control">
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="awardIssuingOrgName" class="w-25 align-self-center">* Issuing Org. Name :</label>
        <div class="w-100">
          <input :class="$v.dataForm.awardIssuingOrgName.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.awardIssuingOrgName.$touch() ||
                 (dataForm.awardIssuingOrgName = (dataForm.awardIssuingOrgName === '') ? savedData.issuing_org_name : dataForm.awardIssuingOrgName)"
                 v-model="dataForm.awardIssuingOrgName"
                 type="text" class="form-control" id="awardIssuingOrgName" required>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.awardIssuingOrgName.required">
              Please enter issuing organization name of your award !
            </div>
            <div v-if="!$v.dataForm.awardIssuingOrgName.minLength">
              Issuing organization name can not contain less than
              {{$v.dataForm.awardIssuingOrgName.$params.minLength.min}} characters !
            </div>
            <div v-if="!$v.dataForm.awardIssuingOrgName.maxLength">
              Please enter a valid issuing organization name of no more than
              {{$v.dataForm.awardIssuingOrgName.$params.maxLength.max}} characters !
            </div>
            <div v-if="!$v.dataForm.awardName.alphaNum">You can't enter special characters !</div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="awardIssuingOrgLink" class="w-25 align-self-center">Issuing Org. Link :</label>
        <div class="w-100">
          <input :class="$v.dataForm.awardIssuingOrgLink.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.awardIssuingOrgLink.$touch()"
                 v-model="dataForm.awardIssuingOrgLink"
                 type="url" class="form-control" id="awardIssuingOrgLink">
          <div class="invalid-feedback">Please enter a valid url of your award issuing organization !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="awardDescription" class="w-25 align-self-center">Description :</label>
        <div class="w-100">
          <textarea :class="$v.dataForm.awardDescription.$error ? 'is-invalid': ''"
                    @blur="$v.dataForm.awardDescription.$touch()" v-model="dataForm.awardDescription"
                    class="form-control" id="awardDescription" placeholder="Enter text here..."></textarea>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.awardDescription.minLength">
              Please enter your award description of at least
              {{$v.dataForm.awardDescription.$params.minLength.min}} characters !
            </div>
            <div v-if="!$v.dataForm.awardDescription.maxLength">
              Your award description must not exceed {{$v.dataForm.awardDescription.$params.maxLength.max}} characters !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="awardSrc" class="w-25 align-self-center">* Source :</label>
        <div class="w-100">
          <input :class="$v.dataForm.awardSrc.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.awardSrc.$touch() ||
                 (dataForm.awardSrc = (dataForm.awardSrc === '') ? savedData.src : dataForm.awardSrc)"
                 v-model="dataForm.awardSrc"
                 type="text" class="form-control" id="awardSrc" required>
          <div class="invalid-feedback">Please enter your award image file source !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="awardType" class="w-25 align-self-center">* Type :</label>
        <div class="w-100">
          <select :class="$v.dataForm.awardType.$error ? 'is-invalid': ''"
                  @blur="$v.dataForm.awardType.$touch()" v-model="dataForm.awardType"
                  id="awardType" class="custom-select" required>
            <option :value="awardType" :key="idx" class="text-capitalize"
                    v-for="(awardType, idx) of getAwardsTypes">{{awardType }}</option>
          </select>
          <div class="invalid-feedback">Please enter an award type !</div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                type="submit" class="btn btn-success" :disabled="$v.dataForm.$invalid">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
import {FORM_AWARDS_VALIDATIONS} from '../../validations/formAwards'
export default {
  name: 'UpdateAward',
  props: [],
  mounted () {},
  created () {
    this.readOneData()
      .then(data => {
        this.savedData = data;
        this.dataForm.awardLink = this.savedData.link;
        this.dataForm.awardName = this.savedData.name;
        this.dataForm.awardDateIssued = this.savedData.date_issued;
        this.dataForm.awardDateExpiration = this.savedData.date_expiration;
        this.dataForm.awardIssuingOrgName = this.savedData.issuing_org_name;
        this.dataForm.awardIssuingOrgLink = this.savedData.issuing_org_link;
        this.dataForm.awardDescription = this.savedData.description;
        this.dataForm.awardSrc = this.savedData.src;
        this.dataForm.awardType = this.savedData.type;
        this.fileToRead = (this.getBaseURL + this.savedData.src);
        this.fileToUpload = true;
        this.fileName = this.savedData.name;
      })
      .catch()
  },
  validations: FORM_AWARDS_VALIDATIONS,
  data () {
    return {
      savedData : null,
      dataForm : {
        awardLink: undefined,
        awardName: undefined,
        awardDateIssued: undefined,
        awardDateExpiration: undefined,
        awardIssuingOrgName: undefined,
        awardIssuingOrgLink: undefined,
        awardDescription: undefined,
        awardSrc: undefined,
        awardType: undefined
      },
      inputFileTouched: false,
      fileToRead: null,
      fileToUpload: null,
      fileName: undefined,
      imageShow: true,
      displayMessage: false,
      message: "",
      messageSubmission: "",
      successUploaded: false
    }
  },
  watch: {
    message : function () {
      let vm = this;
      setTimeout( () => vm.message = "", 5000)
    }
  },
  methods: {
    ...mapActions([
      'setOperation',
      'setCrudComponent',
      'uploadFile',
      'removeFile',
      'readOneData',
      'updateData'
    ]),
    navigateAway(tab) {
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    },
    onSubmit () {
      const formData = {
        award_id : (this.getCurrentElement) ? this.getCurrentElement.id : '',
        link: this.dataForm.awardLink,
        name: this.dataForm.awardName,
        date_issued: this.dataForm.awardDateIssued,
        date_expiration: this.dataForm.awardDateExpiration,
        issuing_org_name: this.dataForm.awardIssuingOrgName,
        issuing_org_link: this.dataForm.awardIssuingOrgLink,
        description: this.dataForm.awardDescription,
        src: this.dataForm.awardSrc,
        type: this.dataForm.awardType
      };
      this.updateData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => this.messageSubmission = '', 5000);
        })
        .catch()
    },
    resetForm () {
      this.dataForm.awardLink = this.savedData.link;
      this.dataForm.awardName = this.savedData.name;
      this.dataForm.awardDateIssued = this.savedData.date_issued;
      this.dataForm.awardDateExpiration = this.savedData.date_expiration;
      this.dataForm.awardIssuingOrgName = this.savedData.issuing_org_name;
      this.dataForm.awardIssuingOrgLink = this.savedData.issuing_org_link;
      this.dataForm.awardDescription = this.savedData.description;
      this.dataForm.awardSrc = this.savedData.src;
      this.dataForm.awardType = this.savedData.type;
      this.fileToRead = (this.getBaseURL + this.savedData.src);
      this.fileToUpload = true;
      this.fileName = this.savedData.name;
    },
    handleFileToUpload () {
      let fileList = this.$refs.fileToUpload.files;
      this.fileToUpload = (fileList.length === 0) ? null : fileList[0];
      this.fileName = (this.fileToUpload !== null) ? this.fileToUpload.name : undefined;
      this.createImage(this.fileToUpload)
    },
    showHideImage () {
      this.imageShow = !this.imageShow
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.fileToRead = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    replaceImage () {
      this.fileToUpload = null;
      this.imageShow = true;
      this.message = '';
      this.displayMessage = false;
    },
    onRemoveFile () {
      this.removeFile(this.dataForm.awardSrc)
        .then(data => {
          this.updateDataVariables(data[0], data[1], data[2]);
          setTimeout( () => this.replaceImage(), 5000)
        })
        .catch();
      this.replaceImage();
    },
    updateDataVariables (bool, text, src) {
      this.successUploaded = bool;
      this.displayMessage = true;
      this.imageShow = false;
      this.message = text;
      this.dataForm.awardSrc = src;
    },
    onUploadFile () {
      let formImage = new FormData();
      formImage.append('fileToUpload', this.fileToUpload);
      formImage.append('from', this.getComponent);
      formImage.append('submit', '');
      this.uploadFile(formImage)
        .then(data => this.updateDataVariables(data[0], data[1], data[2]))
        .catch(data => this.updateDataVariables(data[0], data[1], data[2]))
    }
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getAwardsTypes',
      'getCurrentElement',
      'getBaseURL'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-update-award {}
  label{
    font-weight: bold;
    color: var(--dark-color);
  }
  .uploadBtn{
    border: 1px solid var(--dark-color);
    color: var(--dark-color);
  }
  .uploadBtn:hover{
    background-color: var(--dark-color);
    color: var(--white-color);
  }
  .test{
    display: none;
  }
  @media (min-width: 1200px) {
    .test{
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/awards/UpdateAward.vue